// removed by extract-text-webpack-plugin
module.exports = {"wordRow":"selectionBlock__wordRow___NdDaB","centeredOneBlock":"selectionBlock__centeredOneBlock___3x5GL","centeredTwoBlock":"selectionBlock__centeredTwoBlock___aZuCi","centeredThreeBlock":"selectionBlock__centeredThreeBlock___1JRQX","centeredFourBlock":"selectionBlock__centeredFourBlock___t6xBH","centeredFiveBlock":"selectionBlock__centeredFiveBlock___I9BbV","centeredDynamicBlock":"selectionBlock__centeredDynamicBlock___1zggh","wordColumnBlock":"selectionBlock__wordColumnBlock___2vyLY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/selectionBlock.css
// module id = 234
// module chunks = 0